import { get, post, patch, destroy } from "@/lib/fetcher";

export const getCandidateRefferences = async (candidateId) => {
  return await get(`/admin/candidates/${candidateId}/candidate_refferences`);
};

export const getCandidateRefference = async (candidateId, refferenceId) => {
  return await get(`/admin/candidates/${candidateId}/candidate_refferences/${refferenceId}`);
};

export const createCandidateRefference = async (candidateId, data) => {
  return await post(`/admin/candidates/${candidateId}/candidate_refferences`, data);
};

export const updateCandidateRefference = async (candidateId, refferenceId, data) => {
  return await patch(`/admin/candidates/${candidateId}/candidate_refferences`, refferenceId, data);
};

export const deleteCandidateRefference = async (candidateId, refferenceId) => {
  return await destroy(`/admin/candidates/${candidateId}/candidate_refferences/${refferenceId}`);
};